import React from 'react';

export default () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'>
        <path d='M 2.5 2 C 1.675781 2 1 2.675781 1 3.5 L 1 11.5 C 1 12.324219 1.675781 13 2.5 13 L 7.347656 13 L 11 15.433594 L 11 13 L 12.5 13 C 13.324219 13 14 12.324219 14 11.5 L 14 3.5 C 14 2.675781 13.324219 2 12.5 2 Z M 2.5 3 L 12.5 3 C 12.78125 3 13 3.21875 13 3.5 L 13 11.5 C 13 11.78125 12.78125 12 12.5 12 L 10 12 L 10 13.566406 L 7.652344 12 L 2.5 12 C 2.21875 12 2 11.78125 2 11.5 L 2 3.5 C 2 3.21875 2.21875 3 2.5 3 Z M 4 5 L 4 6 L 11 6 L 11 5 Z M 4 7 L 4 8 L 11 8 L 11 7 Z M 4 9 L 4 10 L 8 10 L 8 9 Z'/>
    </svg>
);
